import defaultTheme from '@basket/themes/default';
import menuTheme from '@basket/themes/menu';
const convertDataAttributes = (attributes) => {
    const returnedObject = {};
    const keys = Object.keys(attributes);
    Object.values(attributes).forEach((value, idx) => {
        const key = keys[idx];
        if (key === 'theme') {
            switch (value) {
                case 'menu':
                    returnedObject[key] = {
                        ...defaultTheme,
                        ...menuTheme,
                    };
                    break;
                case 'page':
                default:
                    returnedObject[key] = { ...defaultTheme };
                    break;
            }
        }
        else {
            try {
                returnedObject[key] = JSON.parse(`${value}`);
            }
            catch (e) {
                returnedObject[key] = `${value}`;
            }
        }
    });
    if (typeof returnedObject.theme === 'undefined') {
        returnedObject.theme = defaultTheme;
    }
    return returnedObject;
};
export default convertDataAttributes;
